/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
import React from "react"
import {  handleSystemConfig } from "../redux/systemConfigSlice"
import { useDispatch } from "react-redux"
import { dataService } from "../services/data.services"
import { useEffect } from "react"
import Profile from "./auth/Profile"

export default function PatientSystemConfig(){
    const dispatch=useDispatch()
    useEffect(()=>{
        const fetchData=async()=>{
            try{
                let response
                response = await dataService.GetAPI(`system-configuration/`);
                if(response.error===false){     
                    dispatch(handleSystemConfig(response.data))
                }      
            }catch(err){
            }  
        }
        fetchData()
        return () => {
            // Cleanup logic, if needed
        };
        
    },[])

    return(
        <>
            <Profile/>
        </>
    )
}